// Production configuration
// Dev/test apiUrl resolves to whatever host the page was loaded from — works unchanged whether
// you open it as localhost:3000 or from a phone via the dev machine's LAN IP (e.g. 192.168.x.x:3000),
// no hardcoded/commented-out IP to keep updating by hand as your network changes.
const devApiUrl = `http://${typeof window !== 'undefined' ? window.location.hostname : 'localhost'}:5001`;

const config = {
  development: {
    apiUrl: devApiUrl
  },
  production: {
    apiUrl: '' // Use relative URLs in production
  },
  test: {
    apiUrl: devApiUrl
  }
};

type Environment = keyof typeof config;
// For React builds, NODE_ENV is available at build time
const environment = (process.env.NODE_ENV as Environment) || 'development';

console.log('Config environment:', environment, 'NODE_ENV:', process.env.NODE_ENV);

export default config[environment];